// extracted by mini-css-extract-plugin
export default {"display":"login_display__O2NMA","Login":"login_Login__NWeS0"};